import { InsuranceType } from '@weave/schema-gen-ts/dist/schemas/insurance-verification/shared/enums.pb';
import { getWeaveToken } from '@frontend/auth-helpers';
import { useInsuranceType } from '../providers/insurance-type-provider';
import { usePersonInfoStore } from '../providers/person-info-provider';

interface GetInsuranceEligibilityReportUrlParams {
  locationId: string;
  personId: string;
  sourceId: string;
  personPMSId: string;
  showTuuthfairyReport?: boolean;
  insuranceType?: InsuranceType;
}

const getInsuranceEligibilityReportUrl = ({
  locationId,
  personId,
  sourceId,
  personPMSId,
  showTuuthfairyReport = false,
  insuranceType = InsuranceType.INSURANCE_TYPE_PRIMARY,
}: GetInsuranceEligibilityReportUrlParams) => {
  const baseUrl = window.location.origin;
  const userToken = getWeaveToken();
  // TODO - SECURITY PROBLEM - NEVER EMBED USER AUTH TOKENS IN URLS
  return `${baseUrl}/insurance-eligibility-report/?locationId=${locationId}&personId=${personId}&sourceId=${sourceId}&personPMSId=${personPMSId}&showTuuthfairyReport=${showTuuthfairyReport}&authToken=${userToken}&insuranceType=${insuranceType}`;
};

type UseOpenInsuranceReportParams = {
  requestId?: string;
  shouldShowTuuthFairyReport?: boolean;
  personLocationId?: string;
  personID?: string;
  personSourceId?: string;
  personPMSID?: string;
};

export const useOpenInsuranceReport = ({
  shouldShowTuuthFairyReport,
  personLocationId = '',
  personID = '',
  personSourceId = '',
  personPMSID = '',
}: UseOpenInsuranceReportParams) => {
  const { personInfo, locationId: locationID } = usePersonInfoStore();
  const personId = (personInfo?.PersonID as string) || personID;
  const sourceId = personInfo?.SourceID || personSourceId;
  const personPMSId = personInfo?.PMID || personPMSID;
  const locationId = locationID || personLocationId || '';

  const { insuranceType } = useInsuranceType();

  const handleOpenInsuranceReport = () => {
    const url = getInsuranceEligibilityReportUrl({
      personId,
      locationId: locationId ?? '',
      sourceId: sourceId ?? '',
      personPMSId: personPMSId ?? '',
      showTuuthfairyReport: shouldShowTuuthFairyReport,
      insuranceType: insuranceType,
    });
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return { handleOpenInsuranceReport, isLoading: false };
};
